// copied from packages/ui/src/components/FlavorFinder/FlavorFinder.tsx
import type { FC } from "react";

import type { FlavorFinderDataType } from "./types/FlavorFinderTypes";

import { FlavorFinderContextProvider, FlavorFinderViewSwitch } from "./components";

import "./FlavorFinder.scss";

export type FlavorFinderProps = {
  data: FlavorFinderDataType;
};

export const FlavorFinder: FC<FlavorFinderProps> = ({ data }) => {
  return (
    <FlavorFinderContextProvider data={data}>
      <div className="flavorfinder">
        <FlavorFinderViewSwitch />
      </div>
    </FlavorFinderContextProvider>
  );
};
